<template>
	<div class="pay-record-detail-container">
		<div class="content">
			<div class="card-wrapper">
				<mobile-card>
					<template slot="title">{{ pageText.pay_info }}</template>

					<template slot="content">
						<div class="flex-form-info">
							<span>{{ pageText.code }}</span>
							<span>{{ selectRecord.orderNo | formatSpaceText }}</span>
						</div>
						<div class="flex-form-info">
							<span>{{ pageText.status }}</span>
							<span>{{ selectRecord.stateStr | formatSpaceText }}</span>
						</div>
						<div class="flex-form-info">
							<span>{{ pageText.money }}</span>
							<span class="money-item">{{ selectRecord.money | formatMoney }}</span>
						</div>
						<div class="flex-form-info">
							<span>{{ pageText.create_time }}</span>
							<span>{{ selectRecord.createTime | formatSpaceText }}</span>
						</div>
						<div class="flex-form-info">
							<span>{{ pageText.pay_type }}</span>
							<span>{{ selectRecord.payType | formatSpaceText }}</span>
						</div>
						<div class="flex-form-info">
							<span>{{ pageText.pay_time }}</span>
							<span>{{ selectRecord.payTime | formatSpaceText }}</span>
						</div>

						<div class="flex-form-info">
							<span>{{ pageText.ticket_title }}</span>
							<span>{{ selectRecord.ticketTitle | formatSpaceText }}</span>
						</div>
					</template>
				</mobile-card>
			</div>
			<div class="card-wrapper">
				<mobile-card>
					<template slot="title">{{ pageText.pay_detail }}</template>

					<template slot="content">
						<div v-for="(item, index) in payDetail" :key="index">
							<div class="flex-form-info">
								<span>{{ getOrderText(item) }}</span>
								<span class="money-item">{{ item.payMoney | formatMoney }}</span>
							</div>
						</div>
					</template>
				</mobile-card>
			</div>
		</div>

		<div class="nav-bottom">
			<van-button
				type="primary"
				size="small"
				square
				style="border-radius: 5px; width: 120px; background-color: #005423"
				@click="openDialog">
				{{ pageText.send_to_email }}
			</van-button>
			<van-button
				type="primary"
				size="small"
				plain
				square
				style="border-radius: 5px; margin-left: 30px; width: 100px; color: #005423; border-color: #005423"
				@click="onBack">
				{{ pageText.pre_page }}
			</van-button>
		</div>
		<van-dialog
			:title="pageText.email_title"
			show-cancel-button
			show-confirm-button
			:confirm-button-text="pageText.confirm"
			:cancel-button-text="pageText.cancel"
			confirmButtonColor="#005423"
			v-model="showDialog"
			:beforeClose="onConfirm">
			<van-field
				v-model="sendToEmail"
				style="padding-left: 10px; width: 100%"
				:placeholder="pageText.email_placeholder"
				input-align="left"
				type="text"></van-field>
		</van-dialog>
	</div>
</template>

<script>
import log from 'utils/log'
import MobileCard from 'components/mobile-card/index'
import MobileButton from 'components/mobile-button/index'
// import { getState } from "utils/state";
import storage from 'good-storage'
import apiChooseFee from 'api/choose-fee'
import apiPayRecord from 'api/pay-record'
import util from '@/utils/util'

export default {
	name: 'payRecordDetail',
	components: { MobileCard },

	data() {
		return {
			showDialog: false,
			sendToEmail: '',
			orderNo: '',
			selectRecord: {},
			pageText: {
				loading: this.$t('pay_situation.loading'),
				pre_page: this.$t('pay_situation.pre_page'),
				pay_info: this.$t('pay_record.detail.pay_info'),
				code: this.$t('pay_record.detail.code'),
				status: this.$t('pay_record.detail.status'),
				money: this.$t('pay_record.detail.money'),
				create_time: this.$t('pay_record.detail.create_time'),
				pay_type: this.$t('pay_record.detail.pay_type'),
				pay_time: this.$t('pay_record.detail.pay_time'),
				ticket_title: this.$t('pay_record.detail.ticket_title'),
				pay_detail: this.$t('pay_record.detail.pay_detail'),
				send_to_email: this.$t('pay_record.detail.send_to_email'),
				email_title: this.$t('pay_record.detail.email_title'),
				email_placeholder: this.$t('pay_record.detail.email_placeholder'),
				confirm: this.$t('pay_record.detail.confirm'),
				cancel: this.$t('pay_record.detail.cancel')
			}
		}
	},

	computed: {
		payDetail() {
			log('details', this.selectRecord.details)
			return this.selectRecord.details
		}
	},

	activated() {
		this.getRecord()
	},

	methods: {
		getRecord() {
			// let r = getState("select-record");
			let r = storage.session.get('select-record', {})
			log('select record ', r)
			if (util.isEmpty(r)) {
				this.$router.push('/home')
				return
			}

			let param = {
				orderNo: r.orderNo,
				outPayNo: r.outPayNo
			}

			apiPayRecord.detail(param).then(res => {
				let d = res.data
				if (util.isNotEmpty(d)) {
					this.orderNo = d.orderNo
					this.selectRecord = d
				}
			})
		},
		openDialog() {
			this.showDialog = true
		},
		onConfirm(action, done) {
			if (action === 'cancel') {
				done()
			} else if (action === 'confirm') {
				let downloadToken = this.selectRecord.downloadToken
				if (downloadToken) {
					downloadToken = util.ensureEncoded(downloadToken)
					apiChooseFee
						.sendEmail({ downloadToken: downloadToken, email: this.sendToEmail })
						.then(res => {
							this.$notify({
								type: 'success',
								message: '邮件已发送'
							})
							done()
						})
						.catch(err => {
							done()
						})
				} else {
					this.$notify({
						type: 'error',
						message: 'token不存在'
					})
				}
			}
		},
		getOrderText(item) {
			let s = ''
			if (item.intervalName) {
				s = `${item.intervalName}  `
				if (item.itemName) {
					let s2 = `${item.itemName}`
					s += s2
				}
			} else {
				if (item.itemName) {
					let s2 = `${item.itemName}`
					s += s2
				}
			}
			return s
		},

		onBack() {
			this.$router.back()
		}
	}
}
</script>

<style lang="scss" scoped>
.nav-bottom {
	width: 100%;
	height: 50px;
	line-height: 40px;
	position: absolute;
	bottom: 0px;
	background-color: white;
	font-size: 16px;
	color: #005423;
	text-align: center;
}
</style>
